import type { CSSProperties, ReactNode } from 'react'
import React from 'react'
import { HorizontalStack, LabelValueBlock, ShowIf } from '@ztechapps/webui.util'
import type { ColProps } from 'react-bootstrap'
import { Col, Form, FormGroup } from 'react-bootstrap'
import type { FieldProps } from 'formik'
import { HelpBlockLayout, HelpTooltip } from './HelpBlockLayout'

export type InlineDisplayContentProps = {
  label?: string | ReactNode
  help?: string | ReactNode
  showHelpAsInline?: boolean
  formikField?: FieldProps
  value?: any
  children?: ReactNode
  meta?: any
  horizontalLayout?: boolean
  horizontalFormLabelWidth?: number
}

export function FormLabel(props: {
  column?: boolean
  md?: ColProps['md']
  showError?: boolean
  style?: CSSProperties
  children: ReactNode
}) {
  return (
    <Form.Label
      style={props.style}
      column={props.column}
      md={props.md}
      // text-danger-emphasis, not text-danger — see HelpBlockLayout.tsx's ErrorBlockLayout for
      // which danger token Bootstrap scopes per theme.
      className={`${props.showError ? 'text-danger-emphasis' : ''} text-capitalize  fw-bold`}
    >
      {props.children}
    </Form.Label>
  )
}

export const InlineDisplayContent = (props: InlineDisplayContentProps) => {
  const meta = props.meta || props.formikField?.meta
  const form = props.formikField?.form
  const error = meta?.error
  let validationState = null
  const metaTouched = meta?.touched || form?.submitCount > 0
  if (metaTouched && !meta.error) validationState = 'success'
  else if (metaTouched && meta?.error) validationState = 'error'

  const showError = validationState === 'error' && !!error
  let formControlContainerWidth = 12
  let formControlLabelWidth = undefined
  if (props.horizontalLayout) {
    formControlLabelWidth = props.horizontalFormLabelWidth ?? 5
    formControlContainerWidth = 12 - formControlLabelWidth
  }

  const rawLabel = (
    <HorizontalStack gap={1}>
      {props.label}
      <HelpTooltip help={props.help} />
    </HorizontalStack>
  )
  const containerLabel = <div className="text-capitalize">{rawLabel}</div>
  const containerContent = props?.value ?? props?.children
  //if it is as horizontal layout use hte LabelValueBlock intead
  if (props.horizontalLayout) {
    return <LabelValueBlock value={containerContent} label={containerLabel} labelWidth={formControlLabelWidth} />
  }

  return (
    <FormGroup>
      <ShowIf condition={!!props.label}>
        <FormLabel column={props.horizontalLayout} md={formControlLabelWidth} showError={showError}>
          {rawLabel}
        </FormLabel>
      </ShowIf>

      <Col md={formControlContainerWidth}>{containerContent}</Col>

      <HelpBlockLayout
        showError={showError}
        meta={meta}
        formikField={props.formikField}
        help={props?.showHelpAsInline ? props.help : undefined}
      />
    </FormGroup>
  )
}
